<div class="order-detail-block">
  <div class="order-detail">
    <div class="table-align-center table-align-center-fixed">
      <div>
        <div>{{ 'ORDER_CODE' | translate }}</div>
        <div>
          <div class="d-inline-flex position-relative">
            <div>
              @if (this.order.category?.id == 1) {
                <img [title]="this.order.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_zayavka.png" />
              }
              @if (this.order.category?.id == 2) {
                <img [title]="this.order.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_incident.png" />
              }
            </div>
            <span>{{ order.id }}</span>
            <dx-button
              (onClick)="onCopyId(order.id)"
              icon="mdi mdi-link-variant"
              class="order-copy"
              hint="{{ 'COPY_ORDER_LINK' | translate }}"></dx-button>
          </div>
        </div>
      </div>

      <div>
        <div>{{ 'IT_SERVICE_CATEGORY' | translate }}</div>
        <div>{{ categoryName }}</div>
      </div>

      <div>
        <div>{{ 'IT_SERVICE' | translate }}</div>
        <div>{{ this.getServiceName() }}</div>
      </div>

      <div>
        <div>{{ 'THEME' | translate }}</div>
        <div>{{ order.title }}</div>
      </div>
    </div>
    <div class="table-align-center table-align-center-fixed">
      <div>
        <div>{{ 'FOR_WHOM' | translate }}</div>
        <div>{{ order.employeeFor?.fio }}</div>
      </div>

      @if (order.coordinator) {
        <div>
          <div>{{ 'COORDINATOR' | translate }}</div>
          <div>{{ order.coordinator?.fio }}</div>
        </div>
      }
      <div>
        <div>{{ 'DESCRIPTION' | translate }}</div>
        <div>{{ order.body }}</div>
      </div>
      @if (order.mark > 0) {
        <div>
          <div>{{ 'EFFICIENCY_MARK' | translate }}</div>
          <div><app-mark [value]="order.mark" [isReadOnly]="true"></app-mark></div>
        </div>
      }
    </div>
  </div>
  <div class="ms-auto mb-auto">
    <dx-button [elementAttr]="{ title: 'Показать детальнее' }" (onClick)="goToOrder(order)" class="btn" icon="mdi mdi-eye"></dx-button>
  </div>
</div>
